import { render, staticRenderFns } from "./CardDimensions.vue?vue&type=template&id=4e712d26&"
import script from "./CardDimensions.vue?vue&type=script&lang=js&"
export * from "./CardDimensions.vue?vue&type=script&lang=js&"
import style0 from "./CardDimensions.vue?vue&type=style&index=0&id=4e712d26&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports